import { type IPais } from "../Ubicacion/entidades/IPais";
import { type ICiudad } from "../Ubicacion/entidades/ICiudad";
import type { IRespuestaApiLista } from "../../globales/interfaces";
import api from "../../utils/api";
export class UbicacionModelo {
    constructor() { }

    public async obtenerPaises(): Promise<IRespuestaApiLista<IPais>> {
        const { data } = await api.get(`/api/Paises/Listar`);
        return data;
    }

    public async obtenerCiudades(): Promise<IRespuestaApiLista<ICiudad>> {
        const { data } = await api.get(`/api/Ciudades/Listar`);
        return data;
    }
}
